import React, { useState, useEffect } from 'react';
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
import { reduxForm } from 'redux-form';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

const AccountOwnerRegulatoryDisclosures1 = ({ nextStep, prevStep, handleSubmit, active, processing, secondary, investAccount }) => {

    const [isSelected, setSelected] = useState(false);

    useEffect(() => {
        if (active && investAccount && investAccount.id) {
            if (secondary) {
                setSelected(investAccount.secondary_account_owner_is_control_person_checked || false);
            } else {
                setSelected(investAccount.primary_account_owner_is_control_person_checked || false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [active, investAccount]);

    useEffect(() => {
        setSelected(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [secondary]);

    const toggleSelection = () => {
        setSelected(!isSelected);
    };

    const handleNext = () => {
        let payload = {};
        if (secondary) {
            payload.secondary_account_owner_is_control_person_checked = isSelected;
        } else {
            payload.primary_account_owner_is_control_person_checked = isSelected;
        }

        nextStep(payload);
    };

    const handleBack = () => {
        prevStep();
    };

    return (
        <div className={`account-setup-wrapper ${!active ? 'd-none' : ''}`}>
            <Form className="form-container" onSubmit={handleSubmit(handleNext)}>
                <div className="back-btn">
                    <Button color="link" onClick={handleBack}>back</Button>
                </div>
                <div className="form-header mt-md-3 mt-0">
                    <h2>{secondary ? 'SECONDARY' : 'PRIMARY'} ACCOUNT OWNER</h2>
                    <span>Please check the required regulatory disclosures</span>
                </div>
                <div className="account-info-container">
                    <FormGroup check className="left-check-minus">
                        <Label check>
                            <Input type="checkbox" onChange={toggleSelection} checked={isSelected} />
                            Check here, if you, your spouse, or any member of your immediate family (including parents, in-laws, siblings, dependents)
                            is a member of the board of directors, 10% shareholder, or policy-making officer of a publicly traded firm.
                        </Label>
                    </FormGroup>
                </div>
                <div className="button_wrapper">
                    <button className="custom-btn-primary" type="submit" disabled={processing}>
                        NEXT STEP {processing && <FontAwesomeIcon icon={faSpinner} spin />}
                    </button>
                </div>
            </Form>
        </div>
    )
};

export default reduxForm({
    form: 'AccountOwnerRegulatoryDisclosures1Form',
})(AccountOwnerRegulatoryDisclosures1);
